import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCommentText = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 1.5,
		stroke: "currentColor",
		fill: "none",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M21.75,18.75h-10.5l-6,4.5v-4.5h-3h-6.55671e-08c-0.828427,-3.62117e-08 -1.5,-0.671573 -1.5,-1.5c0,0 0,0 0,0v-15l1.77636e-14,-1.60927e-07c1.25089e-07,-0.828427 0.671573,-1.5 1.5,-1.5h19.5l-6.55671e-08,3.55271e-15c0.828427,-3.62117e-08 1.5,0.671573 1.5,1.5c0,0 0,1.77636e-15 0,1.77636e-15v15l3.55271e-15,6.55671e-08c0,0.828427 -0.671573,1.5 -1.5,1.5c-7.64678e-08,0 -1.50026e-07,-7.10543e-15 -2.26494e-07,-1.77636e-14Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M5.25,7.5h13.5" }),
			/* @__PURE__ */ _jsx("path", { d: "M5.25,12h10.5" })
		]
	})
});
export default SvgCommentText;
